import React, { useEffect, useState } from 'react';
import axios from 'axios';
import UserLayout from '../../Componets/UserLayout';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Changepassword from '../../Componets/ChangePassword';

export default function Profile() {
  const apiUrl = process.env.REACT_APP_API_URL; // Retrieve the API URL from environment variables
  const [bankDetails, setBankDetails] = useState({
    accountHolderName: '',
    bankName: '',
    branchName: '',
    bankAccountNumber: '',
    ifscCode: '',
  });
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('token');
    const fetchBankDetails = async () => {
      try {
        const config = {
          method: 'post',
          url: `${apiUrl}/api/faculty/BankDetailList`,
          headers: {
            Authorization: token, // Replace with your token
          },
        };
        const response = await axios.request(config);
        const data = response.data[0]; // Assuming only one record is returned
        setBankDetails({
          accountHolderName: data.accountHolderName,
          bankName: data.bankName,
          branchName: data.branchName,
          bankAccountNumber: data.bankAccountNumber,
          ifscCode: data.ifscCode,
        });
      } catch (error) {
        error.response?.status === 401 && navigate('/');
        console.error('Error fetching bank details:', error);
      }
    };

    fetchBankDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    const token = localStorage.getItem('token');
    const data = JSON.stringify({
      bankName: bankDetails.bankName,
      branchName: bankDetails.branchName,
      accountHolderName: bankDetails.accountHolderName,
      bankAccountNumber: bankDetails.bankAccountNumber,
      ifscCode: bankDetails.ifscCode,
    });

    const config = {
      method: 'post',
      url: `${apiUrl}/api/faculty/banck`,
      headers: {
        Authorization: token, // Replace with your token
        'Content-Type': 'application/json',
      },
      data: data,
    };

    try {
      const response = await axios.request(config);
      console.log('Response:', response.data);
      toast.success('Bank details saved successfully');

      setIsEditing(false); // Exit editing mode after saving
    } catch (error) {
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
      console.error('Error saving bank details:', error);
    }
  };

  return (
    <UserLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/UserHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">
                User Profile & Bank Details
              </li>
            </ol>
          </nav>
          <hr className="mb-0" />
          <section className="section profile mt-3">
            <div className="row">
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                    <img
                      src="assets/img/profile-img.png"
                      alt="Profile"
                      className="rounded-circle"
                    />
                    <h2>{bankDetails.accountHolderName}</h2>
                  </div>
                </div>
              </div>
              <div className="col-xl-8">
                <div className="card">
                  <div className="card-body p-3 pb-0">
                    <ul
                      className="nav nav-tabs nav-tabs-bordered"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          data-bs-toggle="tab"
                          data-bs-target="#profile-overview"
                          aria-selected="true"
                          role="tab"
                        >
                          Bank Details
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          data-bs-toggle="tab"
                          data-bs-target="#change-password" // Change this to the correct tab content
                          aria-selected="false"
                          role="tab"
                        >
                          Change Password
                        </button>
                      </li>
                    </ul>
                    <div className="tab-content pt-2">
                      <div
                        className="tab-pane fade show active profile-overview"
                        id="profile-overview"
                        role="tabpanel"
                      >
                        <div className="row">
                          <div className="col-lg-12">
                            <form>
                              {isEditing ? (
                                <>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputAccountHolderName"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Account Holder Name
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="accountHolderName"
                                        value={bankDetails.accountHolderName}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputBankName"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Bank Name
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="bankName"
                                        value={bankDetails.bankName}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputBranchName"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Branch Name
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="branchName"
                                        value={bankDetails.branchName}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputAccountNumber"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Account Number
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="bankAccountNumber"
                                        value={bankDetails.bankAccountNumber}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputIFSCCode"
                                      className="col-sm-4 col-form-label"
                                    >
                                      IFSC Code
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="ifscCode"
                                        value={bankDetails.ifscCode}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="text-end">
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm px-5"
                                      onClick={handleSave}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputAccountHolderName"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Account Holder Name
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={bankDetails.accountHolderName}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputBankName"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Bank Name
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={bankDetails.bankName}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputBranchName"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Branch Name
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={bankDetails.branchName}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputAccountNumber"
                                      className="col-sm-4 col-form-label"
                                    >
                                      Account Number
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={bankDetails.bankAccountNumber}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="inputIFSCCode"
                                      className="col-sm-4 col-form-label"
                                    >
                                      IFSC Code
                                    </label>
                                    <div className="col-sm-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={bankDetails.ifscCode}
                                        readOnly
                                      />
                                    </div>
                                  </div>
                                  <div className="text-end">
                                    <button
                                      type="button"
                                      className="btn btn-secondary  btn-sm px-5 "
                                      onClick={() => setIsEditing(true)}
                                    >
                                      Edit
                                    </button>
                                  </div>
                                </>
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="change-password"
                        role="tabpanel"
                      >
                        <div className="row">
                          <div className="col-lg-12">
                            {/* Change Password Component */}
                            <Changepassword />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <ToastContainer position="top-center" style={{ width: 'auto' }} />
    </UserLayout>
  );
}
